import { render, staticRenderFns } from "./stands-list.vue?vue&type=template&id=4bd5baa1&"
import script from "./stands-list.vue?vue&type=script&lang=js&"
export * from "./stands-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports